import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { toggleScheduleStartTime } from "store/actions";
import { formatTime12hr } from "utils";
import { TOOLTIPS } from "consts";
import Tooltip from "App/common/ui/Tooltip";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function StartTime(props) {
  const [startTime, setStartTime] = useState({
    hrs: "12",
    min: "00",
    meridian: "AM"
  });
  const [focusedField, setFocusedField] = React.useState("hrs");

  useEffect(() => {
    setStartTime(formatTime12hr(props.startTime.value));
  }, [props.startTime.value]);

  const convertToSeconds = time => {
    let hrs = Number(time.hrs || 12);
    let mins = Number(time.min || 0);

    if (time.meridian === "PM" && hrs !== 12) hrs += 12;
    if (time.meridian === "AM" && hrs === 12) hrs = 0;

    return hrs * 3600 + mins * 60;
  };

  useEffect(() => {
    const seconds = convertToSeconds(startTime);
    if (seconds && props.startTime.value !== seconds) {
      props.toggleScheduleStartTime(seconds);
    }
  }, [startTime]);

  const minRef = useRef(null);

  const handleHours = e => {
    let val = e.target.value.replace(/\D/g, "");
    if (!val) {
      setStartTime(p => ({ ...p, hrs: 12 }));
      return;
    }
    if (val.length > 2)
      val =
        val[1] === "1" && Number(val[2]) < 3 && val[0] === "0"
          ? val.slice(1)
          : val[2];
    let num = Number(val) || 12;
    num = Math.min(num, 12);
    const padded = String(num).padStart(2, "0");
    setStartTime(p => ({ ...p, hrs: padded }));
    if (val.length === 2 && minRef.current) minRef.current.focus();
  };

  const handleMinutes = e => {
    let val = e.target.value.replace(/\D/g, "");
    if (!val) {
      setStartTime(prev => ({ ...prev, min: "0" }));
      return;
    }
    if (val.length > 2)
      val = val[0] === "0" && Number(val[1]) < 6 ? val.slice(1) : val[2];
    let num = Number(val);
    if (num > 59) num = 59;
    const padded = String(num).padStart(2, "0");
    setStartTime(p => ({ ...p, min: padded }));
  };

  const toggleMeridian = () => {
    setStartTime(prev => ({
      ...prev,
      meridian: prev.meridian === "AM" ? "PM" : "AM"
    }));
  };

  const handleArrow = direction => {
    setStartTime(prev => {
      let { hrs, min } = prev;

      if (focusedField === "hrs") {
        hrs = direction === "up" ? Number(hrs) + 1 : Number(hrs) - 1;

        if (hrs > 12) hrs = 1;
        if (hrs < 1) hrs = 12;
      }

      if (focusedField === "min") {
        min = direction === "up" ? Number(min) + 1 : Number(min) - 1;

        if (min > 59) min = 0;
        if (min < 0) min = 59;
      }

      return {
        ...prev,
        hrs: String(hrs).padStart(2, "0"),
        min: String(min).padStart(2, "0")
      };
    });
  };

  const handleScroll = e => {
    e.preventDefault();

    if (e.deltaY < 0) {
      handleArrow("up"); // scroll up
    } else {
      handleArrow("down"); // scroll down
    }
  };

  return (
    <>
      <div className="daily_wrap flex_align">
        <h4>Backup start time</h4>
        <Tooltip {...TOOLTIPS.backupSettings.schedule.backupStartTime}>
          <span className="slot_icon">
            <InformationIcon />
          </span>
        </Tooltip>
        <div className="hours_mins_wrap flex_align">
          <div className="id-form__time">
            <span className="id-hr__set">
              <input
                type="text"
                className="idapp-form__control id-hr__vlue"
                value={startTime.hrs}
                onBlur={() => {
                  setStartTime(prev => ({
                    ...prev,
                    hrs:
                      prev.hrs === "" || prev.hrs === "0"
                        ? "12"
                        : String(prev.hrs).padStart(2, "0")
                  }));
                }}
                onFocus={() => setFocusedField("hrs")}
                onWheel={handleScroll}
                onChange={handleHours}
              />
            </span>

            <span className="id-dot">:</span>

            <span className="id-min__set">
              <input
                type="text"
                className="idapp-form__control id-hr__vlue"
                ref={minRef}
                value={startTime.min}
                onBlur={() => {
                  setStartTime(prev => ({
                    ...prev,
                    min:
                      prev.min === "" ? "00" : String(prev.min).padStart(2, "0")
                  }));
                }}
                onFocus={() => setFocusedField("min")}
                onWheel={handleScroll}
                onChange={handleMinutes}
              />
            </span>

            <span className="id-noon__set">
              <p
                className="idapp-form__control id-noon-vlue"
                onClick={toggleMeridian}
              >
                {startTime.meridian}
              </p>
            </span>

            <span className="id-arw__set">
              <button
                className="id-arw__tp"
                onClick={() => handleArrow("up")}
              ></button>

              <button
                className="id-arw__btm"
                onClick={() => handleArrow("down")}
              ></button>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    startTime: state.backupSettings.scheduleInfo.startTime
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleScheduleStartTime
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StartTime);
